import { Toolbar } from './component';


export default Toolbar;
